import { runtime } from "./runtime.mjs";
function hardResetEditor() {
  runtime.hardReset();
}
export {
  hardResetEditor
};
//# sourceMappingURL=hardResetEditor.mjs.map
